import axios from "@/utils/axios.js";

/**
 * Получение списка филиалов
 */
function getFiliations() {
  return new Promise((resolve, reject) => {
    axios
      .get("filiations")
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getFiliationSearch(value) {
  return new Promise((resolve, reject) => {
    axios
        .get(`filiations?search[name]=${value}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение дерева филиалов
 */
function getTreeFiliations(params) {
  return new Promise((resolve, reject) => {
    axios
      .get("filiations/tree", { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Создание филиала
 * @param {String} name
 * @param {Number} parent_id
 * @param {Array} userIds
 */
function createFiliation(name, parent_id, userIds) {
  const departmentData = {
    parent_id,
    name,
    user_ids: userIds,
  };
  return new Promise((resolve, reject) => {
    axios
      .post("filiations", departmentData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Изменение филиала
 * @param {Number} filId
 * @param {String} name
 * @param {Number} parent_id
 * @param {Array} userIds
 */
function updateFiliation(name, parent_id, userIds, filId) {
  const departmentData = {
    name,
    parent_id,
    user_ids: userIds,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`filiations/${filId}`, departmentData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Удаление филиала
 * @param {Number} filId
 */
function deleteFiliation(filId) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`filiations/${filId}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function restoreFiliation(filId) {
  return new Promise((resolve, reject) => {
    axios
        .post(`filiations/${filId}/restore`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение родителя подразделения
 * @param filId
 * @returns {Promise<unknown>}
 */
function getFiliationById(filId) {
  return new Promise((resolve, reject) => {
    axios
        .get(`filiations/${filId}?expand=parent,heads`)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        });
  });
}

export {
  getFiliations,
  createFiliation,
  getTreeFiliations,
  updateFiliation,
  deleteFiliation,
  getFiliationById,
};
